/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * unfurl_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The type of embeddable content for services that support iframe embedding.
 */
export type UnfurlEmbedType =
  (typeof UnfurlEmbedType)[keyof typeof UnfurlEmbedType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnfurlEmbedType = {
  None: 'None',
  Video: 'Video',
} as const;
